'use client'

import { Slot, Slottable } from '@radix-ui/react-slot'
import { forwardRef } from 'react'
import type { MouseEvent } from 'react'

import { ANALYTICS_EVENTS, track } from '@podo-app/analytics/react'

import { cn } from '../../lib/util'
import { ButtonV1Props } from './button-v1.types'

import { buttonV1Style } from './button-v1.css'

/**
 * @deprecated Use Button instead
 */
const ButtonV1 = forwardRef<HTMLButtonElement, ButtonV1Props>(
  (
    {
      variant = 'primary',
      size = 'large',
      shape = 'square',
      asChild = false,
      children,
      className,
      Icon,
      eventParams,
      onClick,
      ...props
    },
    ref,
  ) => {
    const Component = asChild ? Slot : 'button'

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      if (eventParams) {
        track(ANALYTICS_EVENTS.BUTTON_CLICKED, { $version: '1', ...eventParams })
      }
      onClick?.(e)
    }

    return (
      <Component
        className={cn(buttonV1Style({ variant, size, shape }), className)}
        {...props}
        onClick={handleClick}
        ref={ref}
      >
        {Icon && <Icon />}
        {asChild ? <Slottable>{children}</Slottable> : children}
      </Component>
    )
  },
)

ButtonV1.displayName = 'ButtonV1'

export default ButtonV1
